<template>
  <div>
    <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
      {{user.name | userFullName}}
    </span>
    <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
      {{user.department}}
    </span>
    <!-- <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
      {{user.emails[0].value}}
    </span>
    <span class="context--expandlist__subtitle context--text--alignLeft col-25percent">
      {{user.phoneNumbers[0].value}}
    </span> -->
  </div>
</template>

<script>
export default {
  name: 'UserContextCard',
  props: {
    user: { type: Object, default: () => null }
  }
}
</script>

<style lang="scss" scoped>

</style>
